import React, { Fragment } from "react";
import { HorizontalToolbar } from "@theorgchartdev/storybook";
import { BoxLayoutEditorInsertMenu } from "./BoxLayoutEditorInsertMenu/BoxLayoutEditorInsertMenu";
import { BoxLayoutEditorFormatMenu } from "./BoxLayoutEditorFormatMenu/BoxLayoutEditorFormatMenu";
import { BoxLayoutEditorEditMenu } from "./BoxLayoutEditorEditMenu/BoxLayoutEditorEditMenu";
import FinishBoxLayoutEditButton from "@/appComponents/Blocks/Composites/FinishBoxLayoutEditButton/FinishBoxLayoutEditButton";

const MainToolbarBoxLayoutEditor = () => {
  const leftContent = (
    <Fragment>
      <BoxLayoutEditorEditMenu />
      <BoxLayoutEditorInsertMenu />
      <BoxLayoutEditorFormatMenu />
    </Fragment>
  );

  const rightContent = (
    <Fragment>
      <FinishBoxLayoutEditButton />
    </Fragment>
  );

  return <HorizontalToolbar leftContent={leftContent} rightContent={rightContent} size={"large"} />;
};

export default MainToolbarBoxLayoutEditor;
